import { ReportNavigatorService } from '../services/report-navigator.service';
import { OnInit } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
import { AssessmentResult } from 'app/shared/models/assessment-result';
import { PclGraderService } from 'app/reports/services/pcl-grader.service';
var PclSummaryComponent = /** @class */ (function () {
    function PclSummaryComponent(navigator, pclGrader) {
        this.navigator = navigator;
        this.pclGrader = pclGrader;
        this._criteria = [];
    }
    PclSummaryComponent.prototype.ngOnInit = function () {
        if (this.assessmentResult) {
            this._criteria = this.pclGrader.getPCLCriteriaFromAssessmentResult(this.assessmentResult);
        }
    };
    Object.defineProperty(PclSummaryComponent.prototype, "Criteria", {
        get: function () {
            return this._criteria;
        },
        enumerable: true,
        configurable: true
    });
    PclSummaryComponent.prototype.goToScaleResult = function (scaleResult) {
        if (this.navigator.hasNavigationItem(scaleResult.scale.id)) {
            this.navigator.navigate(scaleResult.scale.id);
        }
    };
    return PclSummaryComponent;
}());
export { PclSummaryComponent };



// WEBPACK FOOTER //
// ./src/app/reports/pcl-summary/pcl-summary.component.ts.pre-build-optimizer.js